var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import copyIcon from '../../assets/images/icons/common/icon-copy-gold.png';
function CopyButton(_a) {
    var textToCopy = _a.textToCopy, _b = _a.confirmTextPlacement, confirmTextPlacement = _b === void 0 ? 'top' : _b;
    var t = useI18n().t;
    var _c = React.useState(false), showConfirm = _c[0], setShowConfirm = _c[1];
    function handleCopy(event) {
        event.stopPropagation();
        window.navigator.clipboard.writeText(textToCopy);
        setShowConfirm(true);
    }
    useEffect(function () {
        if (showConfirm) {
            var timeout_1 = setTimeout(function () {
                setShowConfirm(false);
            }, 1000);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [showConfirm]);
    return (_jsxs(Container, { confirmTextPlacement: confirmTextPlacement, onClick: handleCopy, children: [_jsx("img", { alt: "copy", src: copyIcon }), showConfirm && _jsx("div", { className: "confirm-copy", children: t('common.copied') })] }));
}
export default CopyButton;
var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: transparent;\n  height: 32px;\n  padding: 0;\n  position: relative;\n  width: 32px;\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  & > img {\n    height: 100%;\n    width: 100%;\n  }\n\n  & > .confirm-copy {\n    background-color: ", ";\n    border-radius: 4px;\n    /* color: ", "; */\n    font-size: 12px;\n    padding: 4px 8px;\n    position: absolute;\n    top: ", ";\n    bottom: ", ";\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"], ["\n  background-color: transparent;\n  height: 32px;\n  padding: 0;\n  position: relative;\n  width: 32px;\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  & > img {\n    height: 100%;\n    width: 100%;\n  }\n\n  & > .confirm-copy {\n    background-color: ", ";\n    border-radius: 4px;\n    /* color: ", "; */\n    font-size: 12px;\n    padding: 4px 8px;\n    position: absolute;\n    top: ", ";\n    bottom: ", ";\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutCardLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.textPrimary;
}, function (_a) {
    var confirmTextPlacement = _a.confirmTextPlacement;
    return (confirmTextPlacement === 'top' ? '-24px' : '32px');
}, function (_a) {
    var confirmTextPlacement = _a.confirmTextPlacement;
    return (confirmTextPlacement === 'bottom' ? '-24px' : '32px');
});
var templateObject_1;
